import Avatar from '@sdk/components/avatar/Avatar';
import Padding from '@sdk/components/ui/spacing/Padding';
import styled, { useTheme } from 'styled-components';
import DisplayText from '@sdk/components/ui/DisplayText';
import Column from '@sdk/components/ui/spacing/Column';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import Row from '@sdk/components/ui/spacing/Row';
import useAuth from '@sdk/authentication/useAuth';

import LogoImg from '../assets/svg/Misc/logo-navbar.svg';

export const TOP_NAVBAR_HEIGHT = 60;

const Container = styled(Row)`
  height: ${TOP_NAVBAR_HEIGHT}px;
  width: 100%;
  background-color: ${(props): string => props.theme.colors.primary};
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  height: 60px;
  min-width: 100px;
`;

const Menu = styled.div``;

const UserTextContainer = styled.div`
  opacity: 0.65;
  margin-left: 10px;
  transition: all 0.2s linear;

  ${Padding}:hover & {
    opacity: 1;
  }
`;

const OrgTextContainer = styled.div`
  opacity: 0.4;
  margin-left: 10px;
  transition: all 0.2s linear;

  ${Padding}:hover & {
    opacity: 0.8;
  }
`;

const TopNavbar = () => {
  const { currentUser } = useAuth();
  const theme = useTheme();

  return (
    <Container>
      <Row>
        <Logo>
          <LogoImg />
        </Logo>
        <Menu />
      </Row>
      <Row>
        {!!currentUser && (
          <Padding right={30}>
            <Avatar size={36} user={currentUser} avatarBorderColor={theme.colors.iconGray} />
            <Column>
              <UserTextContainer>
                <DisplayText themeColor={ThemeColorType.white} fontSize={14}>
                  {currentUser?.fullname}
                </DisplayText>
              </UserTextContainer>
              <OrgTextContainer>
                <DisplayText themeColor={ThemeColorType.white} fontSize={12}>
                  {currentUser?.org?.name || ' '}
                </DisplayText>
              </OrgTextContainer>
            </Column>
          </Padding>
        )}
      </Row>
    </Container>
  );
};

export default TopNavbar;
